import { render } from "./CreateBIMOrder.vue?vue&type=template&id=0e641e92"
import script from "./CreateBIMOrder.vue?vue&type=script&lang=js"
export * from "./CreateBIMOrder.vue?vue&type=script&lang=js"

import "./CreateBIMOrder.vue?vue&type=style&index=0&id=0e641e92&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__